import React from 'react';
import { Link } from 'react-scroll';
import {
  FaInstagram,
  FaLinkedinIn,
} from 'react-icons/fa';
import './Footer.css';

const footerLinks = [
  { to: 'about', label: 'About' },
  { to: 'actionai', label: 'ActionAI' },
  { to: 'writing', label: 'Writing' },
  { to: 'news', label: 'News' },
  { to: 'speaking', label: 'Speaking' },
  { to: 'contact', label: 'Contact' },
];

const footerSocials = [
  { icon: <FaInstagram />, url: 'https://instagram.com/miriamhaart', label: 'Instagram' },
  { icon: <FaLinkedinIn />, url: 'https://www.linkedin.com/in/miriam-haart/', label: 'LinkedIn' },
];

function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__top">
          <div className="footer__brand">
            <Link to="hero" smooth={true} duration={800} className="footer__logo">
              MIRIAM HAART
            </Link>
            <p className="footer__tagline">
              Ted Speaker, AI Founder, Writer & Activist
            </p>
          </div>

          <nav className="footer__nav">
            {footerLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                smooth={true}
                duration={600}
                offset={-80}
                className="footer__nav-link"
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="footer__social-links">
            {footerSocials.map((s, i) => (
              <a
                key={i}
                href={s.url}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social-link"
                aria-label={s.label}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="footer__divider" />

        <div className="footer__bottom">
          <p>&copy; {new Date().getFullYear()} Miriam Haart. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
